import * as React from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";

import { BodyText, GreenText } from "styles";

import RightArrow from "../../assets/right-arrow-alternative-icon.inline.svg";
import {
  EmailInput,
  EmailWrapper,
  SubmitButton,
} from "./NewsletterInput.styles";

export const NewsletterInput: React.FC = () => {
  const url = `${process.env.GATSBY_MAILCHIMP_URL}/subscribe/post?u=${process.env.GATSBY_MAILCHIMP_U}&id=${process.env.GATSBY_MAILCHIMP_ID}`;

  const [email, setEmail] = React.useState<string>("");

  const handleSubmit = (event, subscribe) => {
    event.preventDefault();
    email &&
      subscribe({
        EMAIL: email,
      });
  };

  return (
    <MailchimpSubscribe
      url={url}
      render={({ status, subscribe }) => (
        <form
          className="lg:ml-8 lg:flex lg:items-center"
          onSubmit={(e) => handleSubmit(e, subscribe)}
        >
          <div className="lg:text-right">
            {status === null && (
              <BodyText $variant="b4impactbold" $hasPadding={false}>
                Subscribe to our <GreenText> newsletter </GreenText> to keep up
                to date with Exponential Markets:
              </BodyText>
            )}
            {status === "sending" && "Subscribing..."}
            {status === "error" && "Error, please try again"}
            {status === "success" && "Subscribed!"}
          </div>
          <EmailWrapper className="my-4 flex flex-1 justify-between lg:my-0 lg:ml-8">
            <EmailInput
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              type="email"
              value={email}
              className="flex-1 px-3 py-2"
              placeholder="Enter your email address"
              disabled={status === "sending" || status === "success"}
            />

            <SubmitButton
              type="submit"
              className="px-4"
              disabled={status === "sending" || status === "success"}
            >
              <RightArrow width="20" height="20" />
            </SubmitButton>
          </EmailWrapper>
        </form>
      )}
    />
  );
};
